import React from "react";
import PopularMovie from "../api/Popular";
import MovieRow from "./MovieRow";

const PopularMov = () => (
  <MovieRow title="Popular Movies" seeAllPath="/PopularA" fetcher={PopularMovie} />
);

export default PopularMov;
